import "./Footer.css";
import UnityLogo from "../../assets/icons/Path 0.png";
import MapPin from "../../assets/icons/MapPin.svg";
import Social from "../../assets/icons/Social.svg";
import PlayStore from "../../assets/icons/google-play-store-logo.svg";
import AppStore from "../../assets/icons/apple-app-store-logo.svg";
import FPX from "../../assets/icons/fpx-logo-vector-01-copy.png";
import Cheque from "../../assets/icons/cheque.svg";
import Bank from "../../assets/icons/bank.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope, faCopyright } from "@fortawesome/free-regular-svg-icons";
import { Link } from "react-router-dom";
import FallbackImg from "../FallbackImg";

const Footerv1 = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        {/* <div className="footer1">
          <div className="subcaption-container">
            <div className="subcaption">
              <span>Join our newsletter</span>
              <br />
              Subscribe to get information, latest news and other
              <br />
              interesting offers about Unity
            </div>
          </div>

          <div className="subscribe-container">
            <div className="subscribe">
              <FontAwesomeIcon icon={faEnvelope} style={{ color: "#798777" }} />
              <input type="text" placeholder="Enter your email address" />
              <button>Subscribe</button>
            </div>
          </div>
        </div> */}

        {/* <div className="footer-line"></div> */}

        <div className="footer2">
          <div className="footerinfo1-container">
            <div className="footerinfo1">
              <FallbackImg
                src={UnityLogo}
                alt="unitylogo"
                style={{ width: "150px", height: "45px" }}
              />
              <div className="footercaption">
                Empowering your choice with
                <br />
                quality and innovation
              </div>
              <div className="address-container">
                <FallbackImg src={MapPin} alt="mappin" width="15" height="15" />
                <div className="address">
                  No 24B, Jalan 1/3, Rawang
                  <br />
                  Integrated Industrial Park,
                  <br />
                  48000 Rawang, Selangor
                </div>
              </div>
              <div className="phoneno-container">
                <FontAwesomeIcon icon={faPhone} style={{ fontSize: "12px" }} />
                <div className="phoneno">017-3750336</div>
              </div>
            </div>
          </div>

          <div className="footerinfo2-container">
            <div className="footerinfo2">
              <ul>
                <li className="footer-subtitle">
                  <strong>Company Info</strong>
                </li>
                <li>
                  <Link to="/aboutus">About Unity</Link>
                </li>
                {/* <li>
                  <Link to="/ourblog">Our Blog</Link>
                </li> */}
                <li>
                  <strong>Help & Support</strong>
                </li>
                <li>
                  <Link to="/brandservicecenter">Repair</Link>
                </li>
                <li>
                  <Link to="/faq">FAQ</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="footerinfo3-container">
            <div className="footerinfo3">
              <ul>
                <li>
                  <strong>More</strong>
                </li>
                <li>
                  <Link to="/privacypolicy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/termsconditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/refundreturnpolicy">Refund & Return Policy</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="footerinfo4-container">
            <div className="footerinfo4">
              <div className="footer-social">
                <a
                  href="https://www.facebook.com/unity.net.malaysia"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="footer-social-part footer-social-left" />
                </a>
                <a
                  href="https://www.instagram.com/unity_malaysia/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="footer-social-part footer-social-middle" />
                </a>
                <a
                  href="https://api.whatsapp.com/send/?phone=60173750336&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="footer-social-part footer-social-right" />
                </a>
              </div>
              {/* <div className="download">
                <strong>Download our app</strong>
                <br />
                <div className="downloadicons">
                  <a href="#googleplaystore">
                    <FallbackImg
                      src={PlayStore}
                      alt="playstore"
                      style={{
                        width: "80px",
                        height: "30px",
                        objectFit: "cover",
                      }}
                    />
                  </a>
                  <a href="#appleappstore">
                    <FallbackImg
                      src={AppStore}
                      alt="appstore"
                      style={{
                        width: "80px",
                        height: "30px",
                        objectFit: "cover",
                      }}
                    />
                  </a>
                </div>
              </div> */}
              <div className="payment">
                <strong>We Accept</strong>
                <br />
                <div className="paymenticons">
                  <FallbackImg src={FPX} alt="fpx" width="50" height="25" />
                  <FallbackImg
                    src={Cheque}
                    alt="cheque"
                    width="40"
                    height="25"
                  />
                  <FallbackImg src={Bank} alt="bank" width="25" height="25" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-line"></div>

        <div className="footer3">
          <FontAwesomeIcon icon={faCopyright} />
          {new Date().getFullYear()} Unity All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Footerv1;
